import { useState } from "react";
import ScrollAnimation from "react-animate-on-scroll";
import SendAskAwayEmail from "../../Util/SendAskAwayEmail";
import CustomDropdown from "../DropDown/CustomDropdown";
import "./ContactUS.css";

const ContactUs = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        subject: "",
        phone: "",
        message: "",
    });

    const [errors, setErrors] = useState({});
    const [success, setSuccess] = useState(false);
    const [countryCode, setCountryCode] = useState("+1");

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleCountryCode = (code) => {
        setCountryCode(code);
    };

    const validateForm = () => {
        let formErrors = {};
        let valid = true;

        if (!formData.name) {
            valid = false;
            formErrors.name = "Name is required.";
        }
        if (!formData.email) {
            valid = false;
            formErrors.email = "Email is required.";
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            valid = false;
            formErrors.email = "Invalid email format.";
        }
        if (!formData.subject) {
            valid = false;
            formErrors.subject = "Subject is required.";
        }
        if (!formData.phone) {
            valid = false;
            formErrors.phone = "Phone number is required.";
        } else if (!/^\d{10}$/.test(formData.phone)) {
            valid = false;
            formErrors.phone = "Enter a valid 10-digit number.";
        }
        if (!formData.message) {
            valid = false;
            formErrors.message = "Message is required.";
        }

        setErrors(formErrors);
        return valid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            try {
                await SendAskAwayEmail({ ...formData, countryCode });
                setSuccess(true);
                setFormData({
                    name: "",
                    email: "",
                    subject: "",
                    phone: "",
                    message: "",
                });
                setTimeout(() => setSuccess(false), 2500);
            } catch (error) {
                console.error("Email send error:", error);
            }
        }
    };

    const handleSubject = (subj) => {
        setFormData({
            ...formData,
            subject: subj,
        });
    };

    return (
        <div className="contact-us-section bg-black text-white">
            <div className="container contact-grid">
                {/* LEFT SIDE */}
                <div className="contact-info">
                    <ScrollAnimation animateIn="bounceInLeft">
                        <h2 className="font-48 cinzel capitalize">Contact Us</h2>
                    </ScrollAnimation>
                    <ScrollAnimation animateIn="bounceInLeft">
                        <p className="font-20 Optima mt-4">
                            We are here to help you about our services.
                        </p>
                    </ScrollAnimation>
                    {/* <ScrollAnimation animateIn="bounceInLeft">
                        <p className="font-20 Optima mt-2">24/7 Support</p>
                    </ScrollAnimation> */}
                    <ScrollAnimation animateIn="bounceInLeft">
                        <p className="font-20 Optima mt-2">Client Services | KhouryCapital</p>
                    </ScrollAnimation>
                    <ScrollAnimation animateIn="bounceInLeft">
                        <p className="font-20 Optima mt-2">support@khourycapital.ca</p>
                    </ScrollAnimation>
                    <ScrollAnimation animateIn="bounceInLeft">
                        <p className="font-20 Optima mt-2">+1 (514) 758-4581</p>
                    </ScrollAnimation>
                   
                </div>

                {/* RIGHT SIDE */}
                <div className="contact-form">
                    <form onSubmit={handleSubmit}>
                        <div className="form-row">
                            <input
                                type="text"
                                name="name"
                                placeholder="Name"
                                value={formData.name}
                                onChange={handleChange}
                                className={errors.name ? "input-error" : ""}
                            />
                            <input
                                type="email"
                                name="email"
                                placeholder="Email"
                                value={formData.email}
                                onChange={handleChange}
                                className={errors.email ? "input-error" : ""}

                            />
                        </div>

                        <div className="form-row" >
                            <div
                                className={[
                                    "new-drop",
                                    errors.subject && "dropdown-error",
                                    formData.subject === "" && "Subject-Color",
                                ]
                                    .filter(Boolean)
                                    .join(" ")}
                            >
                                <CustomDropdown
                                    dropDownLabel={
                                        formData.subject === "" ? "Subject" : formData.subject
                                    }
                                    items={[
                                        { label: "Energy & Commodities", value: "Energy & Commodities" },
                                        { label: "Capital & Transactions", value: "Capital & Transactions" },
                                        { label: "Technology & Innovation", value: "Technology & Innovation" },
                                        { label: "Hospitality & Real Assets", value: "Hospitality & Real Assets" },
                                        { label: "Private Brokerage", value: "Private Brokerage" },

                                    ]}
                                    onSelect={handleSubject}
                                />
                            </div>

                            <div className="phone-input">
                                <CustomDropdown
                                    dropDownLabel={countryCode}
                                    items={[
                                        { icon: "fa-solid fa-flag-usa", label: "+1", value: "+1" },
                                        { icon: "fa-solid fa-flag", label: "+44", value: "+44" },
                                        { icon: "fa-solid fa-flag", label: "+91", value: "+91" },
                                        { icon: "fa-solid fa-flag", label: "+61", value: "+61" },
                                        { icon: "fa-solid fa-flag", label: "+33", value: "+33" },
                                    ]} onSelect={handleCountryCode}
                                />
                                <input
                                    type="number"
                                    name="phone"
                                    placeholder="Phone Number"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    className={errors.phone ? "input-error" : ""}
                                    style={{
                                        MozAppearance: "textfield",
                                        WebkitAppearance: "none",
                                        margin: 0,
                                    }}

                                />
                            </div>
                        </div>

                        <textarea
                            name="message"
                            placeholder="Message"
                            value={formData.message}
                            className={errors.message ? "input-error" : ""}

                            onChange={handleChange}
                        ></textarea>
                        <button type="submit" className="submit-btn">
                            Send
                        </button>
                    </form>
                </div>
            </div >

            {success && (
                <div className="success-popup">
                    <div className="popup-content">
                        <p style={{ color: "black" }} >Your request has been successfully submitted</p>
                        <button onClick={() => setSuccess(false)}>OK</button>
                    </div>
                </div>
            )}
        </div >
    );
};

export default ContactUs;
